import React from 'react';
import { Navbar, Nav, NavItem, Dropdown, NavDropdown, Container, Image, Button, OverlayTrigger, Popover  } from 'react-bootstrap';
import uuid from 'react-uuid';
import axios, { AxiosRequestConfig } from 'axios';
import PropTypes from "prop-types";
import { Constants } from "../constants";
import { BrowserRouter as Router, Route, Link, NavLink, withRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';

class ContractorMenu extends React.Component {

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
            user: props.user,
            contractor: props.contractor,
            currentPage: props.currentPage != null ? props.currentPage : 'self'
        };

        this.logout = this.logout.bind(this);
        this.feedback = this.feedback.bind(this);
    }


    logout() {

        axios.post(`${Constants.apiURL}/api/Identity/Logout`).then(response => {
            this.props.history.push({
                pathname: '/contractor_login'
            });
        }).catch((response) => {
        });
    }

    feedback() {

        this.props.history.push({
            pathname: "/feedback",
            state: {
                previousPage: this.state.currentPage
            }
        });
    }

    render() {
        return (
            <Navbar className="boland-navbar" collapseOnSelect expand="md" defaultExpanded={false} sticky="top">
                <Container style={{ marginLeft: '0px', paddingRight: 0, maxWidth: '100%' }}>
                    <Navbar.Brand as={Link} to={{
                        pathname: "/landing_page",
                        state: {
                            user: this.state.user
                        }
                    }}>
                        <Image src="./Boland block 2.png" width="165px" height="40px" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ml-auto" style={{ width: '100%' }}>
                            
                            <div style={{ width: '100%' }} />
                            <Button size="sm" className="justify-content-end" style={{ justifyContent: 'end', backgroundColor: '#EF4139', minWidth: 'max-content' }} onClick={this.feedback}>
                                Feedback? Let us know here.
                            </Button>
                            <Nav.Link href="https://www.boland.com/training-events" target="_blank">Training</Nav.Link>
                            <Nav.Link href="https://www.boland.com/news" target="_blank">News</Nav.Link>
                            <Button className="justify-content-end" style={{ justifyContent: 'end', backgroundColor: '#1F419B' }} onClick={this.logout}>
                                Logout
                            </Button>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        );
    }
}
export default withRouter(ContractorMenu);